<template>
  <div>
    <trial :dialog="openTrialMsg" :persistant="persistant"></trial>
    <rating :user="currentUser" :dialog="openRating" :week="previousWeek" v-on:closeDialog="openRating = false"></rating>
    <checklist
      v-if="userProfile.fresh"
      :user="currentUser" :userProfile="userProfile" :dialog="openChecklist" :persistant="persistant"
      :measurements="measurements" :startingPhotos="startingPhotos" :goals="goals"
    ></checklist>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { db } from '@/services/firebase'
import rating from '@/components/partial/rating.vue'
import trial from '@/components/partial/trial.vue'
import checklist from '@/components/partial/checklist.vue'
export default {
  components: {
    trial,
    rating,
    checklist
  },
  data () {
    return {
      goals: false,
      persistant: true,
      openRating: false,
      openTrialMsg: false,
      openChecklist: false,
      measurements: null,
      startingPhotos: null
    }
  },
  watch: {
    'userProfile': ['mapDialog']
  },
  mounted () {
    this.mapDialog()
  },
  methods: {
    mapDialog () {
      if (this.userProfile.fresh) {
        this.getMeasurementCheck()
      } else if (this.userProfile.trial) {
        this.checkTrialExpired()
      } else if (!this.userProfile.fresh && !this.userProfile.trial) {
        this.checkCheckin()
      }
    },
    getMeasurementCheck: function () {
      let self = this
      db.collection('user_measurements').where('user_id', '==', self.currentUser).where('milestone', '==', self.userProfile.phase)
        .get().then(function (querySnapshot) {
          if (querySnapshot.empty) {
            self.measurements = false
            self.getPhotosCheck()
          } else {
            self.measurements = true
            self.getPhotosCheck()
          }
        })
        .catch(function (error) {
          console.log('Error getting measurements: ', error)
        })
    },
    getPhotosCheck: function () {
      let self = this
      db.collection('user_photos').where('user_id', '==', self.currentUser).where('milestone', '==', self.userProfile.phase)
        .get().then(function (querySnapshot) {
          if (querySnapshot.empty) {
            self.startingPhotos = false
            self.getGoalsCheck()
          } else {
            if (querySnapshot.size >= 3) {
              self.startingPhotos = true
            } else {
              self.startingPhotos = false
            }
            if (self.currentUser.phase > 1 && self.startingPhotos) {
              self.openChecklist = true
            } else {
              self.getGoalsCheck()
            }
          }
        })
        .catch(function (error) {
          console.log('Error getting photos: ', error)
        })
    },
    getGoalsCheck: function () {
      let self = this
      db.collection('user_goals').where('user_id', '==', self.currentUser)
        .get().then(function (querySnapshot) {
          if (querySnapshot.empty) {
            self.goals = false
          } else {
            self.goals = true
          }
          if (self.measurements && self.startingPhotos && self.goals) {
            self.openChecklist = false
            self.checkFreshCheckin()
          } else {
            self.openChecklist = true
          }
        })
        .catch(function (error) {
          console.log('Error getting workouts: ', error)
        })
    },
    checkFreshCheckin: function () {
      if (this.userProfile.fresh) {
        if (this.userProfile.commenced_at || (this.startingPhotos && this.measurements)) {
          let self = this
          let diffInDays = this.currentDay.diff(this.commencedDate, 'days')
          let diffWeeks = Math.round(diffInDays / 7 * 100) / 100
          let diffWeeksRounded = Math.floor(diffInDays / 7)
          if (diffWeeks > 1) {
            let queryWeek = diffWeeksRounded
            db.collection('ratings').where('user_id', '==', self.currentUser).where('week', '==', queryWeek)
              .get().then(function (querySnapshot) {
                if (querySnapshot.empty) {
                  self.previousWeek = queryWeek
                  self.openRating = true
                } else {
                  self.openRating = false
                }
              })
              .catch(function (error) {
                console.log('Error getting workouts: ', error)
              })
          }
        }
      }
    },
    checkCheckin: function () {
      if (!this.userProfile.fresh) {
        if (this.userProfile.commenced_at && !this.userProfile.disableCheckin && this.daysSinceStart > 6) {
          if (this.checkinRequired() || (this.startingPhotos && this.measurements)) {
            let self = this
            let startOfDay = moment(this.currentDay).startOf('day').unix()
            db.collection('ratings')
              .where('user_id', '==', self.currentUser)
              .orderBy('created_at')
              .startAt(startOfDay)
              .limit(1)
              .get().then(function (querySnapshot) {
                if (querySnapshot.empty) {
                  self.openRating = true
                } else {
                  self.openRating = false
                }
              })
              .catch(function (error) {
                console.log('Error getting last rating: ', error)
              })
          }
        }
      }
    },
    checkinRequired () {
      const latest = localStorage.getItem('latestCheckin')

      if (latest) {
        let isSameDay = moment.unix(latest).isSame(this.currentDay, 'day')

        if (isSameDay) {
          return false
        }

        if (this.isoCheckinDay === this.currentIsoDay) {
          return true
        }
        return false
      } else if (this.isoCheckinDay === this.currentIsoDay) {
        return true
      }
      return false
    },
    checkTrialExpired () {
      if (this.userProfile.trial && this.userProfile.commenced_at) {
        const currentDate = moment()
        const startingDate = moment.unix(this.userProfile.commenced_at)
        const endDate = moment(startingDate).add(5, 'days')
        if (currentDate.isAfter(endDate)) {
          this.openTrialMsg = true
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      userProfile: 'userProfile'
    }),
    previousWeek () {
      if (this.currentDay && this.currentDay) {
        let diffInDays = this.currentDay.diff(this.commencedDate, 'days')
        let diffWeeksRounded = Math.floor(diffInDays / 7)
        let week = diffWeeksRounded
        return week
      }
    },
    currentDay () {
      return moment()
    },
    currentIsoDay () {
      return moment(this.currentDay).isoWeekday()
    },
    commencedDate () {
      return moment.unix(this.userProfile.commenced_at)
    },
    isoCheckinDay () {
      return moment.unix(this.userProfile.commenced_at).isoWeekday()
    },
    daysSinceStart () {
      if (this.userProfile.commenced_at) {
        return moment(this.currentDay).diff(this.commencedDate, 'days')
      }
      return null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/members/dialogController.vue